export const BASE_URL = process.env.REACT_APP_API_URL || 'https://amazon-adcade.mtnsxp.com/api';

export function fetchWithAuth(path, method = 'GET', token, body) {
  const options = { method, headers: {} };

  if (body !== undefined && body !== null) {
    options.headers['Content-Type'] = 'application/json';
    options.body = body;
  }

  if (token) {
    options.headers['Authorization'] = `Bearer ${token}`;
  }

  return fetch(BASE_URL + path, options);
}

export function getWithAuth(path, token) {
  return fetchWithAuth(path, 'GET', token);
}

export function postWithAuth(path, token, body) {
  return fetchWithAuth(path, 'POST', token, body ? JSON.stringify(body) : null);
}